import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const SCheckboxV2 = ({ disabled, value, className, onChange, checkSize = 20, children })=>{
    const [active, setActive] = React.useState(false);
    const [hover, setHover] = React.useState(false);
    return /*#__PURE__*/ _jsxs("div", {
        onMouseDown: ()=>{
            if (disabled) return;
            setActive(true);
            setHover(false);
        },
        onMouseUp: ()=>!disabled && setActive(false),
        onMouseEnter: ()=>!disabled && setHover(true),
        onMouseLeave: ()=>{
            if (disabled) return;
            setActive(false);
            setHover(false);
        },
        className: `${disabled ? "opacity-50 cursor-not-allowed" : hover ? "text-white/70 cursor-pointer" : "cursor-pointer"} flex flex-row items-center justify-start gap-2 transition ${className || ""}`,
        onClick: ()=>{
            !disabled ? onChange?.(!value) : "";
        },
        children: [
            /*#__PURE__*/ _jsx("div", {
                style: {
                    width: checkSize,
                    height: checkSize
                },
                className: `flex flex-row items-center justify-center transition text-grayscale-darkest 
        ${hover ? "scale-[1.05]" : ""}  
        ${active ? "scale-[0.95]" : ""}  ${value ? "bg-brand-primary border border-brand-primary/7" : "bg-grayscale-light text-brand-primary border border-white/10"} rounded-md  `,
                children: /*#__PURE__*/ _jsx("svg", {
                    className: `transition ${value ? "opacity-100" : "scale-[0.1] opacity-0"}`,
                    xmlns: "http://www.w3.org/2000/svg",
                    width: checkSize * 0.6,
                    height: checkSize * 0.6,
                    viewBox: "0 0 16 16",
                    children: /*#__PURE__*/ _jsx("g", {
                        fill: "currentColor",
                        children: /*#__PURE__*/ _jsx("path", {
                            d: "M15.854,3.146l-1.5-1.5c-.195-.195-.512-.195-.707,0L5.5,9.793l-3.146-3.146c-.195-.195-.512-.195-.707,0L.146,8.146c-.195,.195-.195,.512,0,.707l5,5c.098,.098,.226,.146,.354,.146s.256-.049,.354-.146L15.854,3.854c.195-.195,.195-.512,0-.707Z",
                            fill: "currentColor"
                        })
                    })
                })
            }),
            children
        ]
    });
};
SCheckboxV2.displayName = "SCheckboxV2";
export { SCheckboxV2 };
